import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDate, CATEGORY_LABELS } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { ClipboardCheck } from "lucide-react";

export default function QC() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get("/receipts", { params: { status: "MENUNGGU_PEMERIKSAAN" } }),
      api.get("/receipts", { params: { status: "KARANTINA" } }),
    ]).then(([a, b]) => setRows([...a.data, ...b.data]));
  }, []);

  return (
    <div className="space-y-5">
      <div><h1 className="font-heading text-2xl font-extrabold flex items-center gap-2"><ClipboardCheck className="w-6 h-6" /> Pemeriksaan QC</h1>
        <p className="text-sm text-muted-foreground">Penerimaan yang menunggu pemeriksaan mutu MJ-FORM-01 atau dalam karantina.</p></div>
      <Card className="p-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-muted-foreground border-b">
            <th className="py-2 font-medium">Batch Internal</th><th className="font-medium">Tgl</th><th className="font-medium">Bahan</th>
            <th className="font-medium">Kategori</th><th className="font-medium">Pemasok</th><th className="font-medium">Status</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`qc-row-${r.internal_batch}`} className="border-b border-slate-100 hover:bg-accent/50 cursor-pointer" onClick={() => nav(`/receipts/${r.id}`)}>
                <td className="py-2.5"><span className="batch-chip">{r.internal_batch}</span></td>
                <td>{fmtDate(r.tgl_terima)}</td><td>{r.material_name}</td>
                <td className="text-xs">{CATEGORY_LABELS[r.category]}</td><td>{r.supplier_name}</td><td><StatusBadge status={r.status} /></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="py-6 text-center text-muted-foreground">Tidak ada penerimaan menunggu QC.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
